(() => {
  // --- Helpers
  const toOriginalShopifySrc = (src) => {
    try {
      const u = new URL(src, window.location.origin);
      // enlève suffixe Shopify du type _600x600 avant l'extension
      u.pathname = u.pathname.replace(/_(\d+x\d+)(?=\.[a-zA-Z0-9]+$)/, '');
      return u.toString();
    } catch (e) {
      return src;
    }
  };

  // --- Lightbox singleton
  let lb, lbImg, stage;
  let scale = 1, panX = 0, panY = 0;
  let dragging = false, lastX = 0, lastY = 0;

  const applyTransform = () => {
    if (!lbImg) return;
    lbImg.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
    lbImg.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
  };

  const resetTransform = () => {
    scale = 1; panX = 0; panY = 0;
    applyTransform();
  };

  const ensureLightbox = () => {
    if (lb) return;

    lb = document.createElement('div');
    lb.className = 'pomlie-lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML = `
      <button class="pomlie-lightbox__close" type="button" aria-label="Fermer">×</button>
      <div class="pomlie-lightbox__stage">
        <img class="pomlie-lightbox__img" alt="">
      </div>
    `;
    document.body.appendChild(lb);

    lbImg = lb.querySelector('.pomlie-lightbox__img');
    stage = lb.querySelector('.pomlie-lightbox__stage');

    lb.querySelector('.pomlie-lightbox__close').addEventListener('click', closeLightbox);

    // fermer au clic sur l’overlay (mais pas sur l’image)
    lb.addEventListener('click', (e) => {
      if (e.target === lb) closeLightbox();
    });

    // ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLightbox();
    });

    // Double-clic : toggle zoom x2
    stage.addEventListener('dblclick', (e) => {
      e.preventDefault();
      if (scale === 1) {
        scale = 2;
      } else {
        resetTransform();
        return;
      }
      applyTransform();
    });

    // Molette : zoom
    stage.addEventListener('wheel', (e) => {
      e.preventDefault();
      const delta = -Math.sign(e.deltaY) * 0.2;
      const next = Math.min(4, Math.max(1, scale + delta));
      if (next !== scale) {
        scale = next;
        applyTransform();
      }
    }, { passive: false });

    // Drag/pan (seulement si zoom > 1)
    stage.addEventListener('pointerdown', (e) => {
      if (scale <= 1) return;
      dragging = true;
      lastX = e.clientX;
      lastY = e.clientY;
      stage.setPointerCapture(e.pointerId);
      lbImg.style.cursor = 'grabbing';
    });

    stage.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      panX += (e.clientX - lastX);
      panY += (e.clientY - lastY);
      lastX = e.clientX;
      lastY = e.clientY;
      applyTransform();
    });

    stage.addEventListener('pointerup', () => {
      dragging = false;
      applyTransform();
    });
  };

  const openLightbox = (imgEl) => {
    ensureLightbox();
    const src = toOriginalShopifySrc(imgEl.currentSrc || imgEl.src);
    lbImg.src = src;
    lbImg.alt = imgEl.alt || '';
    resetTransform();

    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pomlie-lightbox-open');
  };

  const closeLightbox = () => {
    if (!lb) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pomlie-lightbox-open');
    if (lbImg) lbImg.src = '';
  };

  // --- Init galleries
  const initProGalleries = () => {
    document.querySelectorAll('.pro-gallery').forEach((gallery) => {
      const imgs = Array.from(gallery.querySelectorAll('img'));
      const n = imgs.length;

      gallery.classList.toggle('pro-gallery--1', n === 1);
      gallery.classList.toggle('pro-gallery--2', n === 2);

      // Lightbox click
      imgs.forEach((img) => {
        // évite double binding si Shopify re-render
        if (img.dataset.pomlieZoomBound) return;
        img.dataset.pomlieZoomBound = '1';
        img.addEventListener('click', (e) => {
          e.preventDefault();
          openLightbox(img);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProGalleries);
  } else {
    initProGalleries();
  }
})();
